export default __webpack_public_path__ + "static/media/motion-logo-landing.d7d7a3dc.png";